module.exports = __webpack_public_path__ + "static/img/default.465d26ae.png";